import { Chip } from "@mui/material";
import type { TaskStatus } from "@/types/dealTask";

interface TaskStatusBadgeProps {
  status: TaskStatus;
  size?: "small" | "medium";
}

const STATUS_CONFIG: Record<
  TaskStatus,
  { label: string; color: "default" | "success" }
> = {
  open: { label: "Open", color: "default" },
  completed: { label: "Completed", color: "success" },
};

export function TaskStatusBadge({ status, size = "small" }: TaskStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      variant="outlined"
      sx={{ fontSize: "0.6875rem", height: 22 }}
    />
  );
}
